// @flow
import React from "react"
import HeroSection from "./HeroSection"
import { Inner, Content, Hero, Uppercase } from "./styled"

const SectionHero = () => (
  <HeroSection>
    <Inner>
      <Content>
        <Hero white>
          <Uppercase>
            Welcome to Awayco! This is going to be so much fun.
          </Uppercase>
        </Hero>
      </Content>
    </Inner>
  </HeroSection>
)

export default SectionHero



// WEBPACK FOOTER //
// ./src/pages/AffiliateWelcome/SectionHero/index.js